import { PropsWithChildren, useMemo } from 'react'
import Styles from './Tag.module.scss'

/**
 * A simple tag
 **/
export default function Tag({
  children,
  color = 'default',
  size = 'normal',
  className = '',
  variant = 'filled',
}: PropsWithChildren<{
  color?: 'default' | 'primary'
  size?: 'normal' | 'small'
  className?: string
  variant?: 'filled' | 'outline'
}>) {
  const extra = useMemo(() => {
    if (color === 'primary') return 'dark'
    return ''
  }, [])
  return (
    <div
      className={`${Styles.root} ${Styles[variant]} ${Styles[color]} ${extra} ${Styles[size]} ${className}`}>
      {children}
    </div>
  )
}
